import { render } from "./studioQuery.vue?vue&type=template&id=0b646b08&scoped=true"
import script from "./studioQuery.vue?vue&type=script&lang=js"
export * from "./studioQuery.vue?vue&type=script&lang=js"

import "./studioQuery.vue?vue&type=style&index=0&id=0b646b08&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b646b08"]])

export default __exports__